<style></style>

<template>
  <div class="as-datatable">
    <b-table
      bordered
      striped
      hover
      small
      :busy="!isBusy"
      :items="users"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template v-slot:cell(status)="row">
        <span v-if="row.item.status === 1">Админ</span>
        <span v-else-if="row.item.status === 3">Модератор</span>
        <span v-else-if="row.item.status === 2">Пользователь</span>
        <span v-else-if="row.item.status === 0">Выключеный</span>
      </template>
      <template v-slot:cell(actions)="row">
        <div class="btn-actions">
          <button @click="row.toggleDetails" class="btn btn-primary btn-sm">
            <font-awesome-icon
              v-if="!row.detailsShowing"
              class="as-icon"
              :icon="['fas', 'pencil-alt']"
            />
            <font-awesome-icon
              v-else
              class="as-icon"
              :icon="['far', 'eye-slash']"
            />
          </button>

          <button class="btn btn-danger btn-sm">
            <font-awesome-icon class="as-icon" :icon="['fas', 'trash-alt']" />
          </button>
        </div>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <form action="#" method="POST" @submit.prevent="savePost(row)">
            <div class="form-group">
              <label>Имя: </label>
              <input
                class="form-control"
                type="text"
                name="name"
                :value="row.item.name"
              />
            </div>
            <div class="form-group">
              <label>Email: </label>
              <input
                class="form-control"
                type="text"
                name="email"
                :value="row.item.email"
              />
            </div>
            <div class="form-group">
              <label>Статус: </label>
              <select
                class="form-control"
                name="status"
                v-model.number="row.item.status"
              >
                <option value="default">Выберите статус</option>
                <option value="0">Выключен</option>
                <option value="1">Админ</option>
                <option value="2">Пользователь</option>
                <option value="3">Модератор</option>
              </select>
            </div>
            <div class="actions-btn">
              <button class="btn btn-primary btn-sm" type="submit">
                Сохранить
              </button>
              <button
                class="btn btn-link btn-sm"
                type="button"
                @click.prevent="row.toggleDetails"
              >
                Отменить
              </button>
            </div>
          </form>
        </b-card>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="usersAll"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  props: ["type"],
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      usersAll: 0,
      isBusy: false,
      users: [],
      fields: [
        {
          key: "index",
          label: "№",
          sortable: true
        },
        {
          key: "email",
          label: "email",
          sortable: false
        },
        {
          key: "name",
          label: "Имя",
          sortable: true
        },
        {
          key: "status",
          label: "Статус",
          sortable: true
        },
        {
          key: "actions",
          label: "Действия",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.getPosts();
  },
  methods: {
    async getPosts() {
      if (this.type === "users") {
        console.log("GET users");
        let res = await Axios.get("/.netlify/functions/users-get");
        this.usersAll = res.data.length;
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].data.id = res.data[i].ref["@ref"].id;
          res.data[i].data.index = i + 1;
          this.users.push(res.data[i].data);
        }
        this.isBusy = true;
      } else {
        return [];
      }
    },
    savePost(row) {
      let item = row.item;
      let user = {
        id: item.id,
        name: item.name,
        middle_name: item.middle_name,
        last_name: item.last_name,
        city: item.city,
        email: item.email,
        logo: item.logo,
        phone: item.logo,
        phone_formatted: item.phone_formatted,
        uid: item.uid,
        status: item.status
      };
      Axios.post("/.netlify/functions/user-update", user)
        .then(res => {
          console.log("Save post", res);
          row.toggleDetails(false);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
